"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTimelineLiftUp = function IconTimelineLiftUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M2 9.958v-.54c0-1.557.846-2.133 1.719-2.601l.252-.135c.702-.369.954-.594.954-.963 0-.405-.315-.666-.819-.666-.549 0-1.107.315-1.53.693l-.549-.972C2.54 4.324 3.341 4 4.133 4c1.17 0 1.953.666 1.953 1.665 0 .846-.558 1.431-1.44 1.872l-.261.144c-.657.333-1.098.648-1.098 1.233h2.727v1.044zm7.103.108C7.69 10.066 6.8 9.004 6.8 7.033 6.8 5.071 7.69 4 9.103 4c1.414 0 2.305 1.071 2.305 3.033 0 1.971-.891 3.033-2.305 3.033m0-5.049c-.702 0-1.134.666-1.134 2.016s.432 2.016 1.134 2.016 1.135-.666 1.135-2.016-.433-2.016-1.135-2.016m3.013 4.401v.54h4.014V8.914h-2.727c0-.585.441-.9 1.098-1.233l.261-.144c.882-.441 1.44-1.026 1.44-1.872C16.202 4.666 15.42 4 14.25 4c-.792 0-1.593.324-2.106.774l.55.972c.422-.378.98-.693 1.53-.693.503 0 .818.261.818.666 0 .369-.252.594-.954.963l-.252.135c-.873.468-1.719 1.044-1.719 2.601m4.674-.153.558-.972c.423.396 1.017.72 1.602.72.522 0 .972-.261.972-.801 0-.558-.432-.711-1.188-.711H18.4V6.466h.216c.792 0 1.143-.261 1.143-.729 0-.432-.324-.684-.82-.684-.548 0-1.097.306-1.52.693l-.558-.972c.504-.45 1.314-.774 2.115-.774 1.25 0 1.944.756 1.944 1.638 0 .63-.36 1.062-.891 1.26.513.144 1.053.594 1.053 1.404 0 1.026-.837 1.764-2.124 1.764a3.35 3.35 0 0 1-2.17-.801M7.17 17H2v-2h5.17a3.001 3.001 0 0 1 5.66 0h5.333l-1.586-1.586L17.991 12l4 4-4 4-1.414-1.414L18.163 17h-5.334a3.001 3.001 0 0 1-5.658 0",
    clipRule: "evenodd"
  })));
};

export { IconTimelineLiftUp, IconTimelineLiftUp as default };
